import { usePortal } from '~hooks'
import ReactDOM from 'react-dom'
import { BaseModalProps } from './interfaces'

function BaseModal({ children, innerRef, portalName, onClose, open }: BaseModalProps) {
  const portal = usePortal(portalName)

  if (!portal) return null

  if (!open) return null

  return ReactDOM.createPortal(
    <>
      <div ref={innerRef} />
      <div onClick={onClose}>
        {children}
      </div>
    </>,
    portal
  )
}

BaseModal.defaultProps = {
  open: true,
  portalName: 'user-plan',
}

export default BaseModal